var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"div1"},[_vm._v("企业文化")]),_c('div',{staticClass:"div2"},[_vm._v("Corporate Culture")]),_c('index'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }